<template>
  <div
    class="box-template"
    :class="( newTemplateSelected ===  template.encrypted_id) ? 'selected' : ''"
    v-if="(!template.is_premium || showPremium) && !($t(template.title).includes('cheetah-'))"
  >
    <div class="box-template-overlay">
      <a
        target="_blank"
        v-if="is_wl"
        :href="'https://' + template.title + '.preview.heythisworks.com'"
        class="ba-sm ba-btn	ba-blue">
        <builderall-icon code='eye' style="--builderall-icon-size: 22px;"></builderall-icon>
        <!-- {{ $t('ct-preview') }} -->
      </a>
      <a
        v-else
        :href="`${appUrl}?from=editor#/template-preview/${template.title}`"
        target="_blank"
        class="ba-sm ba-btn	ba-blue">
        <builderall-icon code='eye' style="--builderall-icon-size: 22px;"></builderall-icon>
        <!-- {{ $t('ct-preview') }} -->
      </a>
      <a
        v-if="template.is_premium && !template.has_premium_template_access && !isPremiumUser"
        :href="'https://checkout.builderall.com/payment/premium-template?tp_slug='+template.title"
        class="btn btn-warning text-light"
      >
        {{ $t('ct-buy') }}
      </a>
      <!-- <a
        v-else-if="template.is_premium && !template.has_premium_template_access && isPremiumUser"
        class="btn btn-warning text-light"
        @click="unlockPremiumTemplate(template)"
      >
        {{ $t('ct-unlock') }}
      </a> -->
      <a v-else class="btn btn-default btn-select" @click="startBuilding(template)">
        {{ $t('ct-start-building') }}
      </a>
    </div>

    <div :style="{backgroundImage: `url(${template.thumbnail_portrait})`}" class="img-content" />
    <div v-if="template.is_premium" class="premium-template-tab">
      <i class="svg-icon svgi-crown" ></i>
      <b>Premium</b>
    </div>

    <div class="box-template-info w-100 ba-gp-04">
      <span class="title-template">{{ $t(template.title) }}</span>
      <div v-if="!template.has_premium_template_access" class="amount-template">
        <del v-if="isPremiumUser && template.is_premium">${{ template.amount }}</del>
        <span v-else-if="!template.is_premium">{{ $t('ct-free') }}</span>
        <span v-else>${{ template.amount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxTemplate",
  props: ['newTemplateSelected','template','isPremiumUser','showPremium'],
  computed: {
    appUrl() {
      return typeof process.env.APP_URL !== 'undefined' ? process.env.APP_URL : 'https://cheetah-editor.builderall.com';
    },
    is_wl() {
      return this.$store.state.user && this.$store.state.user.user_domain;
    },

    domain() {
      return typeof process.env.TEMPLATE_DOMAIN !== 'undefined' ? process.env.TEMPLATE_DOMAIN : '.template.builderall.com';
    }
  },
  methods: {
    unlockPremiumTemplate(template){
      this.template.has_premium_template_access = true;
    },
    startBuilding(template){
      // If the template is premium and the user is not premium, unlock the template
      if(template.is_premium && !template.has_premium_template_access && this.isPremiumUser){
        this.unlockPremiumTemplate(template);
      }

      this.$emit('selectTemplate',template.encrypted_id);
      this.$emit('selectedTemplate',template);
    }
  }
}
</script>

<style lang="scss" scoped>
.box-template {
  // display: grid;
  // grid-template-rows: 1fr auto;
  gap: 4px;
  background: #FFFFFF;
  cursor: pointer !important;
  box-shadow: 0 0 2px #0000001A;
  border: 0.5px solid #70707000;
  opacity: 1;
  padding: 5px 6px;
  border-radius: 16px;
  position: relative;
  transition: all 250ms;

  .box-template-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-items: center;
    justify-content: center;
    gap: 16px;
    position: absolute;
    visibility: hidden;
    background: #00000084 0 0 no-repeat padding-box;
    box-shadow: 0 3px 6px #00000029;
    border-radius: 16px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    text-align: center;
    opacity: 0;
    transition: all 0.4s;
    .btn-outline-light, .btn-warning{
      width: 124px;
      height: 43px;
    }

    .btn-outline-light {
      background: #FFFFFF 0% 0% no-repeat padding-box;
      box-shadow: 0.62px 0.79px 2px #1E120D1A;
      border-radius: 5px;
      opacity: 1;
      text-align: left;
      font: 13px/16px Lato;
      letter-spacing: 0px;
      color: #0080FC;
      text-transform: uppercase;
    }

    .btn-select {
      background: #0080FC 0% 0% no-repeat padding-box;
      box-shadow: 0 0 9px #26242429;
      border-radius: 5px;
      opacity: 1;
      font: ExtraBold 13px/16px Muli;
      letter-spacing: 0.39px;
      color: #FFFFFF;
    }
  }

  &:hover {
    .box-template-overlay{
      visibility: visible;
      opacity: 1;
    }
    .premium-template-tab{
      display: none !important;
    }
  }

  &.selected {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 2px 10px #0000001A;
    border: 2px solid #2690F7;
    opacity: 1;
  }

  .premium-template-tab{
    position: absolute;
    top: 19px;
    left: 19px;
    border-radius: 16px;
    padding: 2px 6px;
    border: 1px solid #FFC35C;
    background-color: #FFF6E5;
    display: flex;
    align-items: center;
    gap: 7px;
    b{
      font-size: 10px;
      color: #101623;
    }
  }

  .img-content {
    width: 296px;
    height: 317px;
    border: 1px solid #EFF3F8;
    opacity: 1;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 16px 16px 0 0;
  }
  .box-template-info{
    padding: 8px;
    display: flex;
    justify-content: space-between;
    .title-template {
      max-width: 250px;
      text-align: left;
      font: 16px Lato;
      letter-spacing: 0px;
      color: #363535;
      opacity: 1;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
      font-weight: 600;
      white-space: nowrap;
    }
    &:not(:has(.amount-template)){
      justify-content: center;
    }
    .amount-template{
      font-size: 16px;
      font-weight: 700;
      line-height: 20.08px;
      text-align: left;
      color: #000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/BoxTemplate.vue